<div class="overlay">
  <div class="header">
    <button class="close" (click)="stopScanner()">✕</button>
    <span>Escaneie o QR Code PIX</span>
  </div>

  <div class="scanner-container">
    <!-- Loading -->
    <div class="scanner-loading" *ngIf="isLoading && !cameraError">
      <div class="spinner"></div>
      <span>Abrindo câmera...</span>
    </div>

    <!-- Erro de permissão / câmera -->
    <div class="scanner-error" *ngIf="cameraError">
      <span class="error-icon">⚠️</span>
      <p>{{ cameraError }}</p>
      <button class="retry-btn" (click)="startScanner()">
        Tentar novamente
      </button>
    </div>

    <video #video autoplay muted playsinline></video>

    <div class="qr-frame" *ngIf="!isLoading && !cameraError">
      <div class="scan-line"></div>
    </div>
  </div>
</div>
